import { supabase } from '../lib/supabase'
import type { TutorialId } from './types'

// Persistência remota v2: fonte única em public.tutorial_states
// Colunas: (user_id uuid, tutorial_id text, version int, step_index int, updated_at timestamptz)

// Remove a entrada do tutorial específico em profiles.tutorial_state (sem apagar outras)
export async function clearRemoteTutorial(userId: string, tutorialId: TutorialId): Promise<boolean> {
  try {
    if (!userId || (typeof navigator !== 'undefined' && navigator.onLine === false)) return false
    // 1) Nova fonte: tabela dedicada (preferida)
    try {
      const { error: delErr } = await (supabase as any)
        .from('tutorial_states')
        .delete()
        .eq('user_id', userId)
        .eq('tutorial_id', tutorialId)
      if (delErr) {
        console.warn('[tutorial.persistence] Falha ao deletar em tutorial_states (ignorado se não existir):', delErr)
      }
    } catch (err) {
      console.warn('[tutorial.persistence] Exceção ao deletar em tutorial_states (ignorada):', err)
    }

    return true
  } catch (e) {
    console.warn('[tutorial.persistence] Exceção ao limpar remoto:', e)
    return false
  }
}
// }

export interface RemoteTutorialStateEntry {
  version: number
  stepIndex: number
  updatedAt?: string
}

export interface RemoteTutorialState {
  [tutorialId: string]: RemoteTutorialStateEntry | undefined
}

export async function loadRemoteStep(userId: string, tutorialId: TutorialId): Promise<number | null> {
  try {
    if (!userId || (typeof navigator !== 'undefined' && navigator.onLine === false)) return null

    // Tabela dedicada (única fonte)
    const { data: row, error } = await (supabase as any)
      .from('tutorial_states')
      .select('step_index')
      .eq('user_id', userId)
      .eq('tutorial_id', tutorialId)
      .maybeSingle()
    if (error) {
      console.warn('[tutorial.persistence] Falha na leitura de tutorial_states:', error)
      return null
    }
    if (row && typeof row.step_index === 'number') return row.step_index as number
    return null
  } catch (e) {
    console.warn('[tutorial.persistence] Exceção ao carregar remoto:', e)
    return null
  }
}

export async function saveRemoteStep(userId: string, tutorialId: TutorialId, version: number, stepIndex: number): Promise<boolean> {
  try {
    if (!userId || (typeof navigator !== 'undefined' && navigator.onLine === false)) return false
    const nowIso = new Date().toISOString()

    // 1) Upsert na tabela dedicada (server-wins por updated_at no banco)
    const { error: upErr } = await (supabase as any)
      .from('tutorial_states')
      .upsert({ user_id: userId, tutorial_id: tutorialId, version, step_index: stepIndex, updated_at: nowIso }, { onConflict: 'user_id,tutorial_id' })
    if (upErr) {
      console.warn('[tutorial.persistence] Falha ao upsert em tutorial_states:', upErr)
    }

    return true
  } catch (e) {
    console.warn('[tutorial.persistence] Exceção ao salvar remoto:', e)
    return false
  }
}

export function loadLocalStep(tutorialId: TutorialId, version: number): number | null {
  try {
    const raw = localStorage.getItem(`tutorial:${tutorialId}:v${version}`)
    if (!raw) return null
    const saved = Number(JSON.parse(raw)?.stepIndex)
    if (Number.isNaN(saved)) return null
    return saved
  } catch {
    return null
  }
}

export function saveLocalStep(tutorialId: TutorialId, version: number, stepIndex: number): void {
  try {
    localStorage.setItem(`tutorial:${tutorialId}:v${version}`, JSON.stringify({ stepIndex }))
  } catch { /* ignore */ }
}
